// extracted by mini-css-extract-plugin
module.exports = {"flex":"Flex_flex__145Qo","row":"Flex_row__3NHgq","item":"Flex_item__2XPVF","column":"Flex_column__3uTKb"};